import { useColorScheme } from '@mui/material/styles';
import {
  colorSchemeDarkBlue,
  colorSchemeLight,
  themeQuartz
} from 'ag-grid-enterprise';
import { useMemo } from 'react';

const themeDarkBlue = themeQuartz.withPart(colorSchemeDarkBlue);
const themeLight = themeQuartz.withPart(colorSchemeLight);

export const useGridTheme = () => {
  const { mode: themeMode } = useColorScheme();
  const gridTheme = useMemo(() => {
    return themeMode === 'dark' ? themeDarkBlue : themeLight;
  }, [themeMode]);

  return gridTheme.withParams({
    backgroundColor: 'var(--mui-palette-background-elevation1)',
    wrapperBorderRadius: 0,
    wrapperBorder: 'none',
    autoHeightMinBodyHeight: 0
  });
};

export default useGridTheme;
